import * as angular from 'angular';

import { Category } from '../../models/';
import { IDispatcherService, IDispatcher, ICategoryActionsService } from '../';

export interface ICategoryStoreService {
    getOne: (guid: string) => angular.IPromise<Category>;
    getAll: (force?: boolean) => angular.IPromise<Category[]>;
    addOne: (targetDashboard: Category) => angular.IPromise<Category[]>;
    addMany: (targetDashboards: Category[]) => angular.IPromise<Category[]>;
    updateOne: (targetDashboard: Category) => angular.IPromise<Category[]>;
    updateMany: (targetDashboards: Category[]) => angular.IPromise<Category[]>;
    deleteOne: (guid: string) => angular.IPromise<Category[]>;
    deleteMany: (guids: string[]) => angular.IPromise<Category[]>;
}

export interface ICategoryActionsDispatcherService extends IDispatcherService<ICategoryStoreService> { }

export class CategoryActionsDispatcherService implements ICategoryActionsDispatcherService {
    static serviceId = 'categoryActionsDispatcherService';

    static $inject = ['categoryActionsService'];

    constructor(private _actionService: ICategoryActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ICategoryStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                addOne: (t: Category) => dispatch(actionService.addOne(t)),
                addMany: (t: Category[]) => dispatch(actionService.addMany(t)),
                updateOne: (t: Category) => dispatch(actionService.updateOne(t)),
                updateMany: (t: Category[]) => dispatch(actionService.updateMany(t)),
                deleteOne: (guid: string) => dispatch(actionService.deleteOne(guid)),
                deleteMany: (guids: string[]) => dispatch(actionService.deleteMany(guids))
            }
        };
    }
}